import React from 'react';
import {format} from "date-fns";
import {makeStyles} from "@mui/styles";
import {startWarning, endWarning} from "../ClockIn/shiftService";

const useStyles = makeStyles((theme) => ({
  root: {
    display:'flex',
  },
  separator: {
    padding: '0 6px'
  },
  warning: {
    color: theme.warnColor,
    fontWeight: 'bold'
  }
}));

export default function DisplayTimes({start, end, shift=false, suppressMissingWarnings=false}) {
  const classes = useStyles();


  return (<div className={classes.root}>
      {shift.absent && <span>Absent</span>}
      {!shift.absent && <React.Fragment>
        {start && <span className={`${startWarning(shift, 15) ? classes.warning : null}`}>{format(new Date(start), 'HH:mm')}</span>}
        {!start && <span className={suppressMissingWarnings ? undefined : classes.warning}>{suppressMissingWarnings ? '—' : '?'}</span>}
        <span className={classes.separator}>-</span>
        {end && <span className={`${endWarning(shift, 15) ? classes.warning : null}`}>{format(new Date(end), 'HH:mm')}</span>}
        {!end && <span className={suppressMissingWarnings ? undefined : classes.warning}>{suppressMissingWarnings ? '—' : '?'}</span>}
      </React.Fragment>}
    </div>
  );
}
